import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-280363dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-history-panel" }
const _hoisted_2 = { class: "order" }
const _hoisted_3 = { class: "order-info__description" }
const _hoisted_4 = { class: "years" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "years__title" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.restructuredOrders)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "orders",
          style: _normalizeStyle(_ctx.containerHeight)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
            return (_openBlock(), _createElementBlock("div", {
              key: year,
              class: "order"
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restructuredOrders[year], (order) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: order.id,
                    class: "order-info",
                    style: _normalizeStyle(order.position)
                  }, [
                    _createElementVNode("div", {
                      class: "order-info__logo",
                      style: _normalizeStyle(order.logoColor)
                    }, null, 4),
                    _createElementVNode("div", _hoisted_3, "Заказ " + _toDisplayString(order.id) + " от " + _toDisplayString(order.date), 1)
                  ], 4))
                }), 128))
              ])
            ]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
        return (_openBlock(), _createElementBlock("div", {
          key: year,
          class: "years__title"
        }, [
          _createElementVNode("span", null, _toDisplayString(year), 1)
        ]))
      }), 128)),
      _hoisted_5
    ])
  ]))
}